<script>
    import { afterUpdate, onDestroy } from "svelte";
    import { fade } from "svelte/transition";
    import { sections } from "../stores";
    import Block from "./Block.svelte";
    import { newBlock } from "../constants";
import AddBlockMenu from "./AddBlockMenu.svelte";
    const unsub = $sections;
    export let col;
    export let sectionIndex;
    export let rowIndex;
    export let colIndex;

    let blocks = $sections[sectionIndex].rows[rowIndex].cols[colIndex].blocks;

    function addBlock() {
        console.log(
            $sections[sectionIndex].rows[rowIndex].cols[colIndex].blocks
        );
        $sections[sectionIndex].rows[rowIndex].cols[colIndex].blocks = [
            ...$sections[sectionIndex].rows[rowIndex].cols[colIndex].blocks,
            newBlock,
        ];
        console.log(
            $sections[sectionIndex].rows[rowIndex].cols[colIndex].blocks
        );
    }

    function addCol(){
        $sections[sectionIndex].rows[rowIndex].cols = [
            ...$sections[sectionIndex].rows[rowIndex].cols,
            {
                blocks: [newBlock]
            }
        ]
    }

    let showAddBlockMenu = false;

    function hideBlockMenu(){
        showAddBlockMenu = false;
    }

    function addTextBlock(){
        addBlock(sectionIndex, "text", null);
        return hideBlockMenu(); 
    }
    function addDonationBoxBlock(id){
        addBlock(sectionIndex, 'donationbox', id);
        return hideBlockMenu(); 
    }


    afterUpdate(() => {
        console.log('after col update: ', $sections);
        blocks = $sections[sectionIndex].rows[rowIndex].cols[colIndex].blocks;
    })

    onDestroy(() => {
        $sections = unsub;
    });
</script>

<div class="col df-column">
    <div class="df-addcontent-line" style="transition: all 200ms ease-in-out;" on:click={addCol}>
        <span class="df-plusbutton">+</span>
    </div>

    {#if blocks}
        {#each blocks as block}
            <Block {block} {addBlock} {sectionIndex} {rowIndex} />
        {/each}

    {/if}
</div>

<style>
    .df-column {
        border: 1px solid #ffffff;
        position: relative;
    }
    .df-column:hover .df-addcontent-line {
        visibility: visible;
        background: #242424;
    }
    .df-plusbutton {
        width: 20px;
    height: 19px;
    border-radius: 50%;
    background: #242424;
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5px;
    align-self: center;
    z-index: 99;
    margin-left: -6px;
    }
    .df-addcontent-line {
        border-radius:2px;
        cursor: pointer;
        visibility: hidden;
        width:4px;
        background: #ffffff;
        position: absolute;
        top: 0px;
        right:0px;
        height: 100%;
        display: flex;
    }
    .df-column:hover {
        border: 1px solid #f9f9f9;
    }
</style>
